import React from 'react';
import { ResponsiveContainer, PieChart as RPieChart, Pie, Tooltip } from 'recharts';
import { PieChartProps } from '../types';

const PieChart: React.FC<PieChartProps> = ({ data, title, valueType = 'number' }) => {
  const total = data.reduce((sum, item) => sum + item.value, 0);

  if (total === 0) return null;

  const formatValue = (value: number) => {
    if (valueType === 'currency') {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(value);
    }
    return new Intl.NumberFormat().format(value);
  };

  const chartData = data.map(d => ({
    name: d.fullLabel || d.label,
    label: d.label,
    value: d.value,
    fill: d.color
  }));

  return (
    <div style={{
      backgroundColor: 'white',
      borderRadius: '12px',
      padding: 0,
      width: '100%'
    }}>
      <h3 style={{ margin: '0 0 8px 0', fontSize: '13px', fontWeight: 600, color: '#111827', textAlign: 'center' }}>
        {title}
      </h3>

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div style={{ width: '100%', maxWidth: 200, aspectRatio: '1 / 1', position: 'relative' }}>
          <ResponsiveContainer>
            <RPieChart>
              <Pie
                data={chartData}
                dataKey="value"
                nameKey="name"
                innerRadius="70%"
                outerRadius="100%"
                cornerRadius={8}
                paddingAngle={4}
                stroke="none"
                isAnimationActive
                animationDuration={700}
              />
              <Tooltip
                contentStyle={{
                  backgroundColor: 'rgba(17, 24, 39, 0.95)',
                  border: 'none',
                  borderRadius: 8,
                  color: '#F9FAFB',
                  fontSize: 12,
                  padding: '8px 12px'
                }}
                itemStyle={{ color: '#F9FAFB' }}
                labelStyle={{ color: '#F9FAFB', fontWeight: 600 }}
                formatter={(value, _name, item: any) => {
                  const v = Number(value);
                  const pct = Math.round((v / total) * 100);
                  return [`${formatValue(v)} (${pct}%)`, item?.payload?.name];
                }}
              />
            </RPieChart>
          </ResponsiveContainer>

          {/* Center label */}
          <div style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
            pointerEvents: 'none'
          }}>
            <div style={{ fontSize: 10, color: '#6B7280', textTransform: 'uppercase', letterSpacing: 0.5 }}>
              Total
            </div>
            <div style={{ fontSize: 18, fontWeight: 700, color: '#111827', lineHeight: 1.1 }}>
              {formatValue(total)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PieChart;
